/**
 * App-level ping/pong pair for the Automerge sync WebSocket.
 *
 * The DO registers these with `setWebSocketAutoResponse` so the CF edge answers
 * the ping without waking the (hibernating) DO. The client only sends them on
 * resume events (visibility-visible after long-hidden, `online`) to probe a
 * possibly-zombied socket — not on a periodic schedule.
 *
 * Sent as plain strings, not CBOR: they don't collide with the automerge
 * protocol, and the upstream adapter's onMessage swallows non-decodable frames.
 */
export const SYNC_PING = "hearth-ping";
export const SYNC_PONG = "hearth-pong";
